import * as React from 'react';
import { ITabAttachmentsProps, TBoardAttachmentsTab } from './types';
import { BoardAttachmentsListHOC } from '../../../BoardAttachmentsList/hocs/BoardAttachmentsListHOC';
import { BoardAttachmentsHeaderHOC } from '../../../BoardAttachmentsHeader/hocs/BoardAttachmentsHeaderHOC';
import {
    CLASS_BOARD_ATTACHMENTS,
    CLASS_BOARD_ATTACHMENTS_LOADER_TEXT,
    CLASS_BOARD_ATTACHMENTS_LOADER_TITLE,
    LOADING_PERCENT
} from './constants';
import './_TabAttachments.scss';

export function TabAttachments({
    boardId,
    isGridView,
    onDidMount,
    onLoad
}: ITabAttachmentsProps) {
    const [isLoading, setLoading] = React.useState(true);
    const [searchQuery, setSearchQuery] = React.useState('');
    const [tab, setTab] = React.useState(TBoardAttachmentsTab.ALL);
    const loadedTimer = React.useRef(null);
    const [percent, setPercent] = React.useState(null);

    const className = CLASS_BOARD_ATTACHMENTS;
    const classNameLoader = className + '__loader';
    const classNameProgressBar = className + '__progress-bar';

    const tabAttachmentsLoader = <div className={classNameLoader}>
        <div className={classNameProgressBar}>
            <span className={`${classNameProgressBar}--loading`}></span>
        </div>
        <span className={`${classNameLoader}-title`}>{CLASS_BOARD_ATTACHMENTS_LOADER_TITLE}</span>
        <span className={`${classNameLoader}-text`}>{CLASS_BOARD_ATTACHMENTS_LOADER_TEXT}{percent}%</span>
    </div>

    React.useEffect(() => {
        if (loadedTimer.current) clearInterval(loadedTimer.current);
        loadedTimer.current = setInterval(() => {
            const loadingPercent = sessionStorage.getItem(LOADING_PERCENT);
            setPercent(loadingPercent)
        }, 50);

        onDidMount();

        onLoad().then(() => {
            if (loadedTimer.current) {
                setTimeout(() => {
                    clearInterval(loadedTimer.current);
                    sessionStorage.setItem(LOADING_PERCENT, '0');
                }, 100) //задержка для отображения 100%
            }
            setTimeout(() => {
                setLoading(false);
            }, 300) //для отображения данных загрузки при малом количестве аттачментов
        });
    }, []);

    React.useEffect(() => {
        const progressBar = document.querySelector('.board-attachments__progress-bar--loading') as HTMLElement;
        if (progressBar) {
            progressBar.style.width = `${percent}%`
        }
    }, [percent])

    return (
        <div className={className}>
            {isLoading ?
                tabAttachmentsLoader
                :
                <>
                    <BoardAttachmentsHeaderHOC
                        searchQuery={searchQuery}
                        tab={tab}
                        isGridView={isGridView}
                        onSearchChange={setSearchQuery}
                        onTabChange={setTab}
                    />
                    <BoardAttachmentsListHOC
                        boardId={boardId}
                        searchQuery={searchQuery}
                        tab={tab}
                        isGridView={isGridView}
                    />
                </>
            }
        </div>
    );
}
